const capitalizedMakeList = ['BMW', 'DAF', 'DS', 'GM', 'GMC', 'LDV', 'MG', 'TVR'];

export const getCapitalizedMake = (value?: string) => {
  if (!value || capitalizedMakeList.includes(value)) {
    return value;
  }

  return value
    .toLocaleLowerCase()
    .replace(/(^|-|\s)[a-z]/g, (match) => match.toUpperCase());
};
